(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function attr(el, name) {
    return el ? (el.getAttribute(name) || '') : '';
  }

  function closestItem(el) {
    return el && el.closest ? el.closest('[data-posy-customily-cart-item="true"]') : null;
  }

  function safeUrl(raw, fallback) {
    try {
      return new URL(raw || fallback || '/cart', window.location.origin);
    } catch (e) {
      return new URL(fallback || '/cart', window.location.origin);
    }
  }

  function makeEditUrl(productUrl, key, token, editUrl) {
    var preferred = editUrl || productUrl;
    var url = safeUrl(preferred, productUrl || '/cart');
    if (!editUrl && url.origin !== window.location.origin) url = safeUrl(productUrl, '/cart');
    if (key) url.searchParams.set('posy_customily_replace_key', key);
    if (token) url.searchParams.set('posy_customily_token', token);
    url.searchParams.set('posy_customily_edit', '1');
    url.searchParams.set('posy_customily_return', '/cart');
    return url.toString();
  }

  function textOf(el) {
    return (el && (el.innerText || el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function readCartProperties(item) {
    if (!item) return [];
    return Array.prototype.slice.call(item.querySelectorAll('[data-posy-cart-prop]')).map(function (row) {
      var label = attr(row, 'data-prop-label') || textOf(row.querySelector('.posy-cart-customily-prop__label')).replace(/[:：]\s*$/, '');
      var value = attr(row, 'data-prop-value') || textOf(row.querySelector('.posy-cart-customily-prop__value'));
      return { name: label, value: value };
    }).filter(function (prop) {
      return prop.name && prop.value;
    });
  }

  function storeEditState(button, item, key, editUrl) {
    if (!window.sessionStorage || !item || !key) return;
    var state = {
      key: key,
      editUrl: editUrl || '',
      productUrl: attr(button, 'data-product-url') || attr(item, 'data-posy-cart-product-url'),
      previewSrc: attr(button, 'data-preview-src') || attr(item, 'data-posy-cart-preview-src'),
      title: attr(button, 'data-title') || textOf(item.querySelector('.cart-item__name')),
      price: attr(button, 'data-price') || '',
      properties: readCartProperties(item),
      savedAt: Date.now()
    };
    try {
      window.sessionStorage.setItem('posyCustomilyEdit:' + key, JSON.stringify(state));
      window.sessionStorage.setItem('posyCustomilyEditLatest', JSON.stringify(state));
    } catch (e) {}
  }

  function init() {
    var previewModal = null;
    var previewImage = null;
    var lastPreviewTrigger = null;

    function lockPage(locked) {
      document.documentElement.classList.toggle('posy-cart-modal-lock', !!locked);
    }

    function ensurePreviewModal() {
      if (previewModal) return;
      previewModal = document.createElement('div');
      previewModal.className = 'posy-cart-preview-modal';
      previewModal.hidden = true;
      previewModal.innerHTML = '<div class="posy-cart-preview-modal__backdrop" data-posy-cart-preview-close></div><div class="posy-cart-preview-modal__dialog" role="dialog" aria-modal="true" aria-label="Preview" tabindex="-1" data-posy-cart-preview-close><button type="button" class="posy-cart-preview-modal__close" data-posy-cart-preview-close aria-label="Close">&times;</button><img class="posy-cart-preview-modal__image" alt=""></div>';
      document.body.appendChild(previewModal);
      previewImage = previewModal.querySelector('.posy-cart-preview-modal__image');
      previewModal.querySelectorAll('[data-posy-cart-preview-close]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          if (event.currentTarget.classList.contains('posy-cart-preview-modal__dialog') && event.target !== event.currentTarget) return;
          closePreview();
        });
      });
      if (previewImage) {
        previewImage.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    }

    function previewSourceElement(trigger) {
      var item = closestItem(trigger);
      return (trigger && trigger.querySelector && trigger.querySelector('img')) ||
        (item && item.querySelector('.posy-cart-customily-preview-tile img, .cart-item__image')) ||
        null;
    }

    function sizePreviewFromSource(source) {
      if (!previewImage) return;
      previewImage.style.width = 'min(1200px, 92vw)';
      previewImage.style.height = '';
      previewImage.style.maxHeight = '88vh';
    }

    function openPreview(src, source, trigger) {
      if (!src) return;
      ensurePreviewModal();
      lastPreviewTrigger = trigger || null;
      previewImage.src = src;
      sizePreviewFromSource(source);
      previewModal.hidden = false;
      lockPage(true);
      window.setTimeout(function () {
        var dialog = previewModal.querySelector('.posy-cart-preview-modal__dialog');
        if (dialog) dialog.focus();
      }, 30);
    }

    function closePreview() {
      if (!previewModal) return;
      previewModal.hidden = true;
      lockPage(false);
      if (lastPreviewTrigger && lastPreviewTrigger.isConnected && lastPreviewTrigger.focus) {
        lastPreviewTrigger.focus({ preventScroll: true });
      }
      lastPreviewTrigger = null;
    }

    function openEditPage(button) {
      var item = closestItem(button);
      if (!item) return;
      var productUrl = attr(button, 'data-product-url') || attr(item, 'data-posy-cart-product-url');
      var editUrl = attr(button, 'data-edit-url') || attr(item, 'data-posy-cart-edit-url');
      var key = attr(button, 'data-cart-key') || attr(item, 'data-posy-cart-item-key');
      var token = attr(button, 'data-edit-token') || attr(item, 'data-posy-cart-edit-token');
      storeEditState(button, item, key, editUrl);
      window.location.href = makeEditUrl(productUrl, key, token, editUrl);
    }

    document.addEventListener('click', function (event) {
      var preview = event.target.closest && event.target.closest('[data-posy-cart-preview]');
      if (preview) {
        event.preventDefault();
        openPreview(attr(preview, 'data-preview-src') || attr(closestItem(preview), 'data-posy-cart-preview-src'), previewSourceElement(preview), preview);
        return;
      }

      var edit = event.target.closest && event.target.closest('[data-posy-cart-edit]');
      if (edit) {
        event.preventDefault();
        openEditPage(edit);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && previewModal && !previewModal.hidden) closePreview();
    });
  }

  ready(init);
})();
